import { Attributes, EnumHelper, LookupBase } from '@singularsystems/neo-core';
import { ExportStatus } from '../ExportStatus';

export default class PaymentExportDetailLookup extends LookupBase {

    constructor() {
        super();
        this.makeBindable();
    }

    public readonly paymentExportDetailId: number = 0;

    public readonly paymentExportId: number = 0;

    public readonly myStatementDescription: string = "";

    public readonly beneficiaryName: string = "";

    public readonly beneficiaryAccountNumber: string = "";

    @Attributes.Float()
    public readonly amount: number = 0;

    public readonly status: ExportStatus = ExportStatus.Created;

    public readonly investorName: string = "";

    public readonly investmentRefNo: string = "";

    public readonly recordIsAuthorised: boolean = false;

    // Client only properties / methods

    public get statusText() {
        return EnumHelper.getItemMetadata(ExportStatus, this.status).name;
    }
}